import * as Action from "@actions/index";
import { useDispatch, Store } from "@helpers/Store";

setInterval(() => {
  const current = Store.getState().Main.Time.current;

  useDispatch(Action.Main.Time.setCurrent(current + 1000));
}, 1000);
